import FieldStatus from "../../../../fields3/generic/status/status"
import FieldConfig from "../../../../fields3/proto/field-config"
import ProjectStatusManager from "../../../../gd/manager/project-status-manager"
import ProjectStatus_PopoverMore from "./components/popover/popover-more"
import {ColorPalette, DefaultPaletteColorNumber, ItemColorCoding} from "../../../color-coding/color-coding"
import FieldProjectStatus_TableCell from "./render/table/table-cell"
import Project from "../../../../model2/project/project"

export default class FieldProjectStatus extends FieldStatus {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Project Status";
        this.filterType         = null;

        this.isSearchable       = _.get(config, 'isSearchable', true);

        this.noValueOption      = false

        this.components.PopoverMenuMore = ProjectStatus_PopoverMore

        this.renderComponents.tableCell = FieldProjectStatus_TableCell
    }

    canEdit(model: Project): boolean {
        return model.acl.canChangeStatus
    }

    access(model:any) {
        return gd.ac.check.project.fullAccess(model.id) ? 'write' : 'read';
    }

    _getOption(value:any) {

        // try dynamic status
        let status = gd.session.statuses.get(value)
        if (status) {
            return status.exportToOption()
        }

        // esli mi popali suda to zopa ... netu status u project chto delat' neponyatno...
        console.error("ERROR #PROJECT-NO-STATUS-1")
    }

    getOptionsForEdit(model:any) {
        const options = ProjectStatusManager.getProjectStatusOptions(model)
        return options
    }

    getColorCoding(model: any): ItemColorCoding {
        const value = _.get(model, this.fieldId, null)
        const status = gd.session.statuses.get(value)

        return {
            colorNumber         : status?.color || DefaultPaletteColorNumber.STATUS,
            corePalette         : ColorPalette.STATUS
        }
    }
}
